// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import VueResource from 'vue-resource'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
import App from './App'
import router from './router/index'
import Auth from './packages/Auth'
import { baseApi } from './configs/urls'
import { store } from './store'
import locale from 'element-ui/lib/locale/lang/es'

Vue.use(VueResource)
Vue.use(Auth)
Vue.use(ElementUI, { locale })

Vue.config.productionTip = false

Vue.http.options.root = baseApi
Vue.http.headers.common['Accept'] = 'application/json'
Vue.http.interceptors.push(function (request, next) {
  if (Vue.auth.isAuthenticated()) {
    request.headers.set('Authorization', 'Bearer ' + Vue.auth.getToken())
  }

  next((response) => {
    if (response.status === 401) {
      Vue.auth.destroyToken()
      location.reload()
    }
  })
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.guest)) {
    if (Vue.auth.isAuthenticated()) {
      next({
        path: '/dashboard'
      })
    } else {
      next()
    }
  } else if (to.matched.some(record => record.meta.auth)) {
    if (!Vue.auth.isAuthenticated()) {
      next('/login')
    } else {
      const hasPermission = to.matched.some(item => !!item.meta.permission)
      if (hasPermission) {
        const permission = to.matched.filter(item => !!item.meta.permission)
          .map(item => item.meta.permission)
        if (!Vue.auth.hasPermission(permission[0])) {
          next('/')
        }
      }
      next()
    }
  } else {
    next()
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js